module.exports = __webpack_public_path__ + "img/windows_thumb.90ec9772.jpg";